import ApiClient from '@/api/client';
import Config from '../../services/config.service';
const config = new Config();
const path = require('path');

class UsersAPI extends ApiClient {

  constructor() {
    super();
  }

  async getUsersList(filters, page = 1) {
    let route = path.join(
      this.USERGROUP_API_PATH,
      `users/?page_size=${config.itemsPerPage.users}&page=${page}`
    );
    for (const filter in filters) {
      route = route.concat('', `&${filter}=${filters[filter].join(',')}`);
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async orderUsersList(direction, field, filters, page = 1) {
    let route = path.join(
      this.USERGROUP_API_PATH,
      `users/?page_size=${config.itemsPerPage.users}&page=${page}&ordering=${direction}${field}`
    );
    for (const filter in filters) {
      route = route.concat('', `&${filter}=${filters[filter].join(',')}`);
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async getUser(id) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `users/${id}/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async searchUser(search) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `users-find-by-email/?email=${search}`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async createUser(data) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      'users/'
    );
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }
  async updateUser(id, data) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `users/${id}/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async patchUser(id, data) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `users/${id}/`
    );
    const response = await this.patch(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async deleteUser(id) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `users/${id}/`
    );
    const response = await this.delete(route);
    return response.status === 204;
  }
}
const usersAPI = new UsersAPI();
export default usersAPI;
